const translations = {
  en: {
    "Meet your ": "Meet your ",
    "money person": "money person",
    "Log in or create your account.": "Log in or create your account.",
    "Enter your email": "Enter your email",
    "Continue with Email": "Continue with Email",
    "or continue with": "or continue with",
    "Check your email": "Check your email",
    "We sent a 6-digit code to": "We sent a 6-digit code to",
    "Invalid verification code": "Invalid verification code",
  },
  "zh-tw": {
    "Meet your ": "認識你的",
    "money person": "理財專家",
    "Log in or create your account.": "登入或建立你的帳號。",
    "Enter your email": "輸入你的電子郵件",
    "Continue with Email": "以電子郵件繼續",
    "or continue with": "或繼續使用",
    "Check your email": "查看你的電子郵件",
    "We sent a 6-digit code to": "我們已寄出 6 位數驗證碼至",
    "Invalid verification code": "驗證碼無效",
  },
};

export default translations;
